import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClientInfoService } from './client-info.service';

@Injectable()
export class ClientHeadersInterceptor implements HttpInterceptor {

  constructor(private clientInfo: ClientInfoService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const clientId = this.clientInfo.clientId;
    // Browsers and WKWebView drop User-Agent set from JS; X-Feenics-Client is the reliable one.
    return next.handle(req.clone({
      setHeaders: {
        'User-Agent': clientId,
        'X-Feenics-Client': clientId
      }
    }));
  }
}
